<div class="profile-flex-container">
  <div class="profile-flex">
    <app-profile-sidebar activePage="membership-profile"  class="z-2 profile-sidebar m-w-100" ></app-profile-sidebar>

    <ng-container *ngIf="myMembership && membershipCard">
      <app-memberhsip-card
        (callGetMembershipFunction)="getMemberships(false)"
        (showConnectMembership)="showConnectMembership()"
        *ngIf="myMembership && membershipCard"
        class="membership-flex w-100"
        [membershipCard]="membershipCard">
      </app-memberhsip-card>

      <p class="description mt-6">
        <span class="description">{{ "MEMBERSHIP.DOWNLOAD_FORM_INFO" | translate }} </span>
        <a class="link" href="mailto:clanstvo@nk-rijeka.hr"> clanstvo&#64;nk-rijeka.hr</a>
      </p>

      <a
        [href]="'img/' + page + '/pristupnica.pdf'"
        download
        target="_blank"
        class="btn btn-primary mt-4"
      >
        {{ "MEMBERSHIP.DOWNLOAD_FORM" | translate }}
      </a>
    </ng-container>

    <ng-container *ngIf="isMembershipLoaded && ((membershipCard && !membershipCard.isActive) || !membershipCard)">
      <h2 class="profile-title" *ngIf="isMembershipLoaded && !membershipCard">{{ "MEMBERSHIP.MEMBERS_OF_CLUB" | translate }}</h2>

      <p class="profile-description mt-5">{{ "MEMBERSHIP.MEMBERSHIP_DESCRIPTION" | translate }}</p>

      <div class="profile-membership-container mt-5">
        <div class="profile-membership-container-content">
          <p class="subtitle" *ngIf="isMembershipLoaded && membershipCard && !membershipCard?.isActive">{{ "MEMBERSHIP.NO_CONNECTED_ACTIVE_MEMBERSHIP" | translate }}</p>

          <ng-container *ngIf="isMembershipLoaded && !membershipCard">
            <p class="subtitle" >{{ "MEMBERSHIP.NO_CONNECTED_MEMBERS" | translate }}</p>
            <p class="description mt-5">{{ "MEMBERSHIP.BECOME_MEMBER" | translate }}</p>

            <div class="buttons-flex">
              <ng-container *ngIf="becomingMemberDisabled; else normalView">
                <div class="disabled-becoming-member">
                  <button class="btn btn-secondary" [disabled]="becomingMemberDisabled" (click)="openMembershipModal()">
                    {{ "FOOTER.BECOME_MEMBER" | translate }}
                  </button>
                  <span class="tooltip-become-member">{{ "NAVIGATION.TOOLTIP_MEMBERSHIP" | translate }}</span>
                </div>
              </ng-container>
              <ng-template #normalView>
                <button class="btn btn-secondary" (click)="openMembershipModal()">
                  {{ "FOOTER.BECOME_MEMBER" | translate }}
                </button>
              </ng-template>

              <a
                [href]="'img/' + page + '/pristupnica.pdf'"
                download
                target="_blank"
                class="btn btn-primary"
              >
                {{ "MEMBERSHIP.DOWNLOAD_FORM" | translate }}
              </a>
            </div>

            <p class="description mt-4">
              <span>{{ "MEMBERSHIP.DOWNLOAD_FORM_INFO" | translate }} </span>
              <a class="link" href="mailto:clanstvo@nk-rijeka.hr"> clanstvo&#64;nk-rijeka.hr</a>
            </p>
          </ng-container>

          <p class="description mt-5" *ngIf="isMembershipLoaded && !membershipCard?.isActive">{{ "MEMBERSHIP.NO_CONNECTED_MEMBERS_DESCRIPTION" | translate }}</p>

          <form
            [formGroup]="connectMembershipForm"
            (ngSubmit)="onSubmitConnectMembership(connectMembershipForm)"
            class="form user-form"
            *ngIf="isMembershipLoaded && !membershipCard?.isActive"
            >
            <div class="user-form-input" [class.invalid]="connectMembershipForm.get('barcode')?.invalid && connectMembershipForm.get('barcode')?.touched">
              <label class="user-form-input-label" for="barcode">{{ "MEMBERSHIP.INPUT_BARCODE" | translate }} *</label>
              <input type="number" name="barcode" formControlName="barcode" class="form-control" placeholder=" " data-name="connect-new-membership-input" (input)="removeErrorMessage()" (input)="limitInputLengthForNumberic($event)" />
            </div>

            <div class="user-form-input" [class.invalid]="connectMembershipForm.get('birthDate')?.invalid && connectMembershipForm.get('birthDate')?.touched">
              <label class="user-form-input-label" for="birthDate">{{ "MEMBERSHIP.INPUT_DATE" | translate }} *</label>
              <input id="birth-date" type="text" name="birthDate" mask="00.00.0000" formControlName="birthDate" class="form-control" placeholder=" " data-name="connect-new-membership-input" />
            </div>

            <p class="success-message" *ngIf="infoMessage">{{ infoMessage }}</p>

            <button class="btn btn-primary">{{ "MEMBERSHIP.CONNECT_MEMBERSHIP" | translate }}</button>
          </form>

          <p class="error-message mt-5" *ngIf="errorMessageMyMembership">{{ errorMessageMyMembership }}</p>

          <ng-container *ngIf="isMembershipLoaded && !membershipCard">
            <p class="subtitle mt-5">{{ "MEMBERSHIP.INFO" | translate }}</p>
            <ul>
              <li>{{ "MEMBERSHIP.INFO_1_1" | translate }}</li>
              <li>{{ "MEMBERSHIP.INFO_1_2" | translate }}</li>
            </ul>

            <p class="subtitle mt-5">{{ "MEMBERSHIP.INFO_2" | translate }}</p>
            <ul>
              <li>{{ "MEMBERSHIP.INFO_2_1" | translate }}</li>
              <li>{{ "MEMBERSHIP.INFO_2_2" | translate }} <a class="link" href="mailto:clanstvo@nk-rijeka.hr">clanstvo&#64;nk-rijeka.hr</a> {{ "MEMBERSHIP.INFO_2_2_2" | translate }}</li>
              <li>
                {{ "MEMBERSHIP.INFO_2_3" | translate }}
                <a
                  [href]="'img/' + page + '/pristupnica-odrasli.pdf'"
                  download
                  target="_blank"
                  class="link"
                >
                  {{ "MEMBERSHIP.DOWNLOAD_FORM_ADULT" | translate }}
                </a>
              </li>
              <li>
                {{ "MEMBERSHIP.INFO_2_4" | translate }}
                <a
                  [href]="'img/' + page + '/pristupnica.pdf'"
                  download
                  target="_blank"
                  class="link"
                >
                  {{ "MEMBERSHIP.DOWNLOAD_FORM" | translate }}
                </a>
              </li>
            </ul>

            <p class="subtitle mt-5">{{ "MEMBERSHIP.INFO_3" | translate }}</p>
            <ul>
              <li>{{ "MEMBERSHIP.INFO_3_1" | translate }}</li>
              <li>{{ "MEMBERSHIP.INFO_3_2" | translate }}</li>
            </ul>

            <p class="mt-5 description">* {{ "MEMBERSHIP.INFO_4" | translate }}</p>
            <p class="description">** {{ "MEMBERSHIP.INFO_5" | translate }}</p>
          </ng-container>
        </div>

        <div class="profile-membership-container-img" *ngIf="isMembershipLoaded && !membershipCard">
          <img class="player" [src]="'img/' + page + '/membership/player.png'" alt="" />
          <img class="img-text" [src]="'img/' + page + '/membership/zajedno-tekst.png'" alt="" />

          <div class="info-content">
            <p>{{ "MEMBERSHIP.INFO_6" | translate }}</p>
            <p>{{ "MEMBERSHIP.INFO_7" | translate }}</p>


            <ng-container *ngIf="becomingMemberDisabled; else normalView">
              <div class="disabled-becoming-member">
                <button class="btn btn-secondary mt-5" [disabled]="becomingMemberDisabled" (click)="openMembershipModal()">
                  {{ "FOOTER.BECOME_MEMBER" | translate }}
                </button>
                <span class="tooltip-become-member">{{ "NAVIGATION.TOOLTIP_MEMBERSHIP" | translate }}</span>
              </div>
            </ng-container>
            <ng-template #normalView>
              <button class="btn btn-secondary mt-5" (click)="openMembershipModal()">
                {{ "FOOTER.BECOME_MEMBER" | translate }}
              </button>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="mt-5 profile-membership-info">
        <div class="profile-membership-info-content">
          <p>{{ "MEMBERSHIP.INFO_8" | translate }}</p>
          <p>HNK Rijeka s.d.d.</p>
          <p>Rujevica 10, 51000 Rijeka</p>
          <p>MB 3344975</p>
          <p>OIB 38726608831</p>
          <p>IBAN HR3224020061100134749</p>
        </div>

        <div class="profile-membership-info-content">
          <p>{{ "MEMBERSHIP.INFO_9" | translate }}</p>
          <p>HNK Rijeka</p>
          <p>Odjel za članstvo</p>
          <p>E-mail: clanstvo&#64;nk-rijeka.hr</p>
          <p> Telefon: +385 (0)51 563627</p>
          <p>ULAZNICE +385 (0)51 563640</p>
        </div>
      </div>
    </ng-container>

  </div>
</div>

<app-notification *ngIf="showNotification" [bodyText]="bodyText | translate"></app-notification>
